import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";

interface IDeletePaymentProps {
  paymentId: string;
}

export async function deletePayment({ paymentId }: IDeletePaymentProps) {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/payment/${paymentId}`,
    {
      method: "DELETE",
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
